
import { useEffect } from "react";

export default function TawkChat() {
    useEffect(() => {
        const script = document.createElement("script");

        script.async = true;
        script.src = "https://embed.tawk.to/6a3e47ebbf47421d4a0c9d6d/1js1khucr";
        script.charset = "UTF-8";
        script.setAttribute("crossorigin", "*");

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return null;
}